export const resourceFullText = resource => {
  switch(resource.type) {
    case 'newspaper':
    case 'website':
      return resource.advertorial.pages.map(page => page.text_body).join('')
    case 'social':
      return resource.advertorial.caption
  }
  return null
}

// TODO: pick these dynamically?
const ALLOWED_METADATUM_KEYS = [
  'brand', 'family_people', 'celebrities', 'collaboration_details', 'collaboration_years',
  'event_detail', 'event_year', 'fashion_photographer', 'collection', 'collection_year',
  'journalist', 'stylist'
]

export const visibleMetadataFields = resource => {
  return Object.keys(resource.metadata).reduce((acc, k) => {
    const metadatum = resource.metadata[k]
    if (metadatum.enabled) {
      Object.keys(metadatum)
            .filter(metadatumKey => metadatum[metadatumKey])
            .filter(metadatumKey => !['enabled', 'status'].includes(metadatumKey))
            .filter(metadatumKey => ALLOWED_METADATUM_KEYS.includes(metadatumKey))
            .forEach(metadatumKey => {
              acc[metadatumKey] = metadatum[metadatumKey]
            })
    }
    return acc
  }, {})
}

export const resourceImages = resource => {
  switch(resource.type) {
    case 'newspaper':
    case 'magazine':
      return resource.advertorial.pages.map(page => page.medium)
    case 'website':
      return [] // TODO: return only included in text images
    case 'social':
      return resource.advertorial.media
  }
  return []
}
